let mailKeys = {};

mailKeys['mexico']=['@infinitummail.com', '@gmail.com', '@yahoo.com'];
mailKeys['default']=['@prodigy.com', '@gmail.com', '@hotmail.com'];
mailKeys['argentina']=['@outlook.com', '@gmail.com', '@hotmail.com'];

export default mailKeys;



// WEBPACK FOOTER //
// ./src/components/Keyboard/layouts/tvMailKeys.js